import React, { useState } from 'react';
import { Badge, IconButton, Popover } from '@mui/material';
import { NotificationsOutlined } from '@mui/icons-material';
import { useNotificationCount } from '../../hooks/useNotifications';
import { NotificationPanel } from './NotificationPanel';

export const NotificationBell: React.FC = () => {
  const { data: count = 0 } = useNotificationCount();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ color: 'rgb(107,114,128)' }}
      >
        <Badge
          badgeContent={count}
          color={count > 0 ? 'error' : 'default'}
          max={99}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.65rem',
              minWidth: 16,
              height: 16,
            },
          }}
        >
          <NotificationsOutlined sx={{ fontSize: 22 }} />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              width: 400,
              maxHeight: 520,
              borderRadius: 2,
              boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
              mt: 1,
            },
          },
        }}
      >
        <NotificationPanel onClose={() => setAnchorEl(null)} />
      </Popover>
    </>
  );
};
